export default __webpack_public_path__ + "static/media/france.dbc1d37b.svg";